angular.module('app').component('myClassificationOverview', {
    templateUrl: 'classification/template/my-classification-overview.tmpl.html',
    bindings: {
        overview: '<'
    },
    controller: ["firstLetterUppercaseFilter", "addSemesterFilter", function (firstLetterUppercaseFilter, addSemesterFilter) {}]
});